import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getLocaleString } from "@utils/locale";

import * as dykDatabase from "./did_you_know.json";

interface Fact {
  fact: string;
  source: string;
  type: string;
}

interface DykDatabase {
  [locale: string]: {
    long: Fact[];
    short: Fact[];
  };
}

export const DidYouKnow = () => {
  const { t } = useTranslation();
  const locale = getLocaleString();
  const [fact, setFact] = useState<Fact | null>(null);
  const [opacity, setOpacity] = useState(0);
  useEffect(() => {
    const database = dykDatabase as DykDatabase;

    const getRandomFact = () => {
      const randomFact =
        database[locale]?.short[
          Math.floor(Math.random() * database[locale].short.length)
        ] ?? null;
      return randomFact;
    };

    const changeFact = () => {
      setOpacity(0);

      setTimeout(() => {
        const newFact = getRandomFact();
        setFact(newFact);
        setOpacity(1);
      }, 1000);
    };

    const initialFact = getRandomFact();
    // oxlint-disable-next-line react-hooks/set-state-in-effect
    setFact(initialFact);
    setOpacity(1);
    const interval = setInterval(changeFact, 8000);

    return () => clearInterval(interval);
  }, [locale]);

  return (
    <div className="flex flex-col gap-6 md:gap-8 min-h-[200px]">
      <div className="text-cnam-blue text-center text-sm md:text-[20px] font-jakarta font-bold">
        {t("loader.didYouKnow")}
      </div>
      <div
        className={`text-center text-strong text-sm md:text-[20px] font-jakarta lleading-[20px] md:leading-[30px] transition-opacity duration-1000 ease-in-out`}
        style={{ opacity }}
      >
        {fact?.fact}
      </div>
      {fact?.source && (
        <div
          className={`text-center text-strong text-sm md:text-[20px] font-jakarta transition-opacity duration-1000 ease-in-out`}
          style={{ opacity }}
        >
          {`Source: ${fact.source}`}
        </div>
      )}
    </div>
  );
};
